module.exports = {
	extends: [
		'/',
		'base',
		'tabStrip',
		'tabStrip'
	],

	actions: {
		addTab: {
			source: {
				tab: {
					componentData: {
						component: [
							'base',
							'tabStrip',
							'big',
							'tab'
						]
					}
				}
			}
		}
	}
};
